export default __webpack_public_path__ + "static/media/Bansal.aab626b8.png";